<script setup lang="ts">
import { defineProps, onMounted, ref } from 'vue'
import { generatePaymentQrCode, OrderResponseObject } from '../../utilities/api'
import { getPlatformName } from '../../utilities/usePlatformSettings'
import { getCampaignData } from '../../utilities/investment-process/useCampaign'

const props = defineProps<{
    amount: number
    reference: string
    order?: OrderResponseObject
}>()

const qrCodeData = ref()

onMounted(async () => {
    qrCodeData.value = (
        await generatePaymentQrCode(getPlatformName(), {
            asset_uid: getCampaignData()?.asset_data.asset_uid,
            amount: props.amount,
            payment_reference: props.reference,
        })
    ).data
})
</script>

<template>
    <img :src="qrCodeData" class="w-full" alt="" />
</template>
